// Load Bootstrap JS
import bootstrap from 'bootstrap'

// Load Styles
import '../scss/main.scss';
import initEmailAddress from "./modules/init_email_address";
import initScrollBlock from "./modules/init_scroll_block";
import initSlider from "./modules/init_slider";
import initPhotoSwipe from "./modules/init_photoswipe";
import initGlobalPopup from "./modules/init_global_popup";
// Demo of using .env variables
// console.log(`Google Maps API Key: ${process.env.GOOGLE_MAPS_API_KEY}`);

window.addEventListener('load',()=>{
  initEmailAddress('.ks-email');
  initScrollBlock();
  initSlider();
  initPhotoSwipe();
  initGlobalPopup();
})
